import styled, { css } from 'styled-components'
import { darken, lighten } from 'polished'
import { Link } from 'gatsby'
import { breakpoints } from 'src/utils/styles/global-styles'
import { GatsbyImage } from 'gatsby-plugin-image'

export const Section = styled.div`
  background-color: ${(props) => props.theme.cream};
`

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 0px;
  @media (max-width: ${breakpoints.xl}px) {
    flex-direction: column-reverse;
  }
  @media (max-width: ${breakpoints.s}px) {
    padding-top: ${(props) => (props.topPadding ? '20px' : '0px')};
  }
`

export const VideoContainer = styled.div`
  position: relative;
  width: 70%;
  height: 50%;
  @media (max-width: ${breakpoints.xl}px) {
    margin-left: 0px;
  }
  @media (max-width: ${breakpoints.l}px) {
    min-width: 50%;
    width: 100%;
    margin-left: 10%;
  }
`

export const HeroVideo = styled.video`
  width: 100%;
  max-height: 100%;
  border-radius: 56px 0px 0px 56px;
  @media (max-width: ${breakpoints.xl}px) {
    border-radius: 56px;
    margin-bottom: 10px;
  }
  @media (max-width: ${breakpoints.l}px) {
    border-radius: 40px 0px 0px 40px;
    margin-bottom: 0px;
  }
`

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  font-weight: normal;
  margin: 0;
  flex-shrink: 1.7;
  font-family: 'MatterRegular';
  padding: 0% 5%;
  width: ${(props) => (props.isSeasonalState ? '60%' : '80%')};
  @media (max-width: ${breakpoints.xl}px) {
    flex-shrink: 1;
    align-items: center;
    margin-top: 20px;
    width: ${(props) => (props.isSeasonalState ? '70%' : '80%')};
  }
  @media (max-width: ${breakpoints.l}px) {
    margin-top: 1rem;
    max-width: 80vw;
    margin-bottom: 30px;
    .yotpo-sr-bottom-line-summary {
      margin: 20px 0;
    }
  }
  @media (max-width: ${breakpoints.m}px) {
    max-width: 100vw;
    width: 100%;
    .yotpo-sr-bottom-line-summary {
      margin: 20px 0px 10px;
    }
  }
  @media (max-width: ${breakpoints.s}px) {
    margin-top: 0px;
    margin-bottom: 10px;
    padding: auto;
  }
`

export const CenteredContent = styled.p`
  text-align: center;
  display: ${(props) => (props.hide ? 'none' : 'block')};
`

export const CenteredOnMobile = styled.div`
  text-decoration: none;
  margin-top: 40px;
  @media (max-width: ${breakpoints.xl}px) {
    text-align: ${(props) => (props.amazon ? 'center' : 'left')};
  }
  @media (max-width: ${breakpoints.l}px) {
    margin-top: 40px;
    text-align: center;
  }
  @media (max-width: ${breakpoints.s}px) {
    margin-top: 30px;
  }
`

const linkStyle = css`
  font-family: 'MatterRegular';
  background-color: ${(props) => props.theme.coral};
  color: white;
  text-decoration: none;
  border-radius: 28px;
  border: none;
  font-size: 18px;
  padding: 15px 30px;
  letter-spacing: 0.09px;
  &:hover {
    cursor: pointer;
    background-color: ${(props) => darken(0.1, props.theme.coral)};
  }
  &:focus {
    outline: none;
    box-shadow: ${(props) => `0 0 0 0.2rem ${lighten(0.1, props.theme.coral)}`};
  }
  @media (max-width: ${breakpoints.m}px) {
    font-size: 16px;
    letter-spacing: 0.08px;
  }
  @media (max-width: 375px) {
    padding: 15px 16px;
    font-size: 15px;
  }
`

export const BuyNowLink = styled(Link)`
  ${linkStyle}
  background-color: ${(props) => props.theme.coral};
  &:hover {
    cursor: pointer;
    background-color: ${(props) => darken(0.1, props.theme.coral)};
  }
  &:focus {
    outline: none;
    box-shadow: ${(props) => `0 0 0 0.2rem ${lighten(0.1, props.theme.coral)}`};
  }
`

export const BuyNowAnchor = styled.a`
  ${linkStyle}
`
export const AmazonBuyNow = styled.a`
  ${linkStyle}
  display: block;
  text-align: center;
  background-color: #f6d936;
  color: ${(props) => props.theme.grayDark};
  &:hover {
    background-color: #f6d936;
    opacity: 0.8;
  }
  &:focus {
    box-shadow: 0 0 0 0.2rem ${lighten(0.1, '#f6d936')};
  }
`

export const Text = styled.h1`
  font-family: ${(props) => (props.isSeasonalState ? 'P22MackinacProBold' : 'P22MackinacProBook')};
  font-size: ${(props) => (props.isSeasonalState ? '34px' : '38px')};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: 0.19px;
  text-align: left;
  margin: ${(props) => (props.isSeasonalState ? '0px' : '20px 0px 10px')};
  color: ${(props) => props.theme.grayDark};
  width: 100%;
  @media (max-width: 1450px) {
    font-size: 34px;
  }
  @media (max-width: 1250px) {
    font-size: 30px;
  }
  @media (max-width: ${breakpoints.xl}px) {
    text-align: center;
    font-size: 32px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: ${(props) => (props.isSeasonalState ? '28px' : '30px')};
    line-height: 37px;
    letter-spacing: 0.15px;
  }
  @media (max-width: 400px) {
    font-size: ${(props) => (props.isSeasonalState ? '24px' : '21px')};
    line-height: 30px;
    letter-spacing: 0.15px;
  }
`

export const SubHeader = styled.h3`
  font-family: 'MatterRegular';
  color: ${(props) => props.theme.grayDark};
  font-size: 28px;
  margin: 0px 0px 30px;
  @media (max-width: ${breakpoints.xl}px) {
    font-size: 24px;
  }
  @media (max-width: ${breakpoints.l}px) {
    text-align: center;
    font-size: 20px;
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: 16px;
    margin: -15px 0px 5px;
  }
`

export const Item = styled.div`
  display: flex;
  align-items: flex-start;
`
export const ListItem = styled.p`
  font-size: 20px;
  letter-spacing: 0.04px;
  margin: ${(props) => (props.isSeasonalState ? '0px 0px 0px 5px' : '2px 0px 2px 5px')};
  @media (max-width: ${breakpoints.l}px) {
    font-size: 18px;
  }
  @media (max-width: 420px) {
    font-size: 15px;
  }
  @media (max-width: ${breakpoints.s}px) {
    text-align: center;
  }
  @media (max-width: 375px) {
    font-size: 15px;
  }
  @media (max-width: 350px) {
    font-size: 14px;
  }
  @media (max-width: 330px) {
    font-size: 13px;
  }
`
export const CheckMark = styled(GatsbyImage)`
  margin-top: 10px;
  min-width: 20px;
  width: 20px;
  @media (max-width: ${breakpoints.l}px) {
    margin-top: 6px;
  }
`
export const ExternalLink = styled(GatsbyImage)`
  min-width: 14px;
  width: 14px;
  margin-left: 5px;
  margin-top: 3px;
`

export const Subheading = styled.h1`
  font-family: 'MatterRegular';
  font-size: ${(props) => (props.isSeasonalState ? '20px' : '26px')};
  line-height: 28px;
  margin: ${(props) => (props.isSeasonalState ? '0px' : '10px 0px 10px')};
  text-align: left;
  @media (max-width: ${breakpoints.xl}px) {
    font-size: 24px;
    line-height: 26px;
    text-align: center;
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: 16px;
    line-height: 24px;
    margin: 0px;
  }
`
export const Disclosure = styled.p`
  margin-top: 32px;
  line-height: 1.2;
  @media (max-width: ${breakpoints.s}px) {
    text-align: center;
  }
`
export const BogoContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 130px;
  @media (max-width: ${breakpoints.l}px) {
    right: 7%;
  }
  @media (max-width: ${breakpoints.m}px) {
    width: 80px;
    top: 10px;
  }
`
export const BogoFrameContainer = styled.div`
  position: absolute;
  top: 96px;
  left: 51%;
  width: 130px;
  @media (max-width: ${breakpoints.xl}px) {
    width: 100px;
  }
  @media (max-width: ${breakpoints.l}px) {
    left: 72%;
    top: 400px;
  }
  @media (max-width: 850px) {
    left: 71%;
    top: 360px;
  }
  @media (max-width: ${breakpoints.m}px) {
    top: 345px;
    width: 80px;
  }
  @media (max-width: 720px) {
    top: 315px;
  }
  @media (max-width: 670px) {
    top: 270px;
  }
  @media (max-width: ${breakpoints.s}px) {
    left: 73%;
    top: 260px;
    width: 50px;
  }
  @media (max-width: 550px) {
    top: 3%;
  }
  @media (max-width: 420px) {
    top: 165px;
  }
  @media (max-width: 360px) {
    top: 150px;
  }
`
export const ShippingDetail = styled.p`
  font-size: 14px;
  color: ${(props) => props.theme.coral};
  margin-top: ${(props) => (props.calendar ? '-8px' : '-24px')};
  white-space: pre-line;
  font-family: 'MatterRegular';
  @media (max-width: ${breakpoints.xl}px) {
    text-align: ${(props) => (props.calendar ? 'left' : 'center')};
  }
  @media (max-width: ${breakpoints.l}px) {
    text-align: center;
    margin-bottom: ${(props) => (props.calendar ? '8px' : '16px')};
  }
  @media (max-width: ${breakpoints.s}px) {
    font-size: 12px;
    line-height: 1.2;
  }
`
export const Eyebrow = styled.span`
  font-family: ${(props) => (props.inSeasonalState ? 'MatterBold' : 'MatterRegular')};
  font-size: ${(props) => (props.inSeasonalState ? '12px' : '22px')};
  font-style: normal;
  font-weight: 400;
  line-height: ${(props) => (props.inSeasonalState ? '18px' : '120%')};
  letter-spacing: ${(props) => (props.inSeasonalState ? '1px' : '-0.484px')};
  @media (max-width: ${breakpoints.xl}px) {
    padding: 10px;
    font-size: ${(props) => (props.inSeasonalState ? '12px' : '18px')};
  }
  @media (max-width: ${breakpoints.l}px) {
    width: 100%;
    text-align: center;
  }
  @media (max-width: ${breakpoints.m}px) {
    display: block;
  }
`
